import React from "react";
import PropTypes from "prop-types";
import _values from "lodash/values";

import { QUESTION_FLOW } from "lib/constants";
import { questionProps } from "lib/propTypes";
import { getCommuteData, saveCommuteData } from "lib/util";
import { post } from "redux/fetch";

export default class PrefCommuteLengthQuestion extends React.PureComponent {
    static propTypes = {
        ...questionProps,
        flow: PropTypes.oneOf(_values(QUESTION_FLOW)).isRequired,
        handleAnswer: PropTypes.func.isRequired,
    };

    state = {
        address: (getCommuteData() || {}).address || null,
        addressLoading: false,
        geohash: undefined,
        onboarding: this.props.flow === QUESTION_FLOW.ONBOARD,
        selectValue: 120,
    };

    componentDidMount() {
        window.initAutocomplete(this.address, {
            callback: (ac) => (this.autocomplete = ac),
            onChange: this.onAddressChange,
        });

        if (!this.state.onboarding) {
            this.updateAnswer(); // Enable next button
        }
    }

    componentWillUnmount() {
        if (this.autocomplete) {
            this.autocomplete.unbindAll();
        }
    }

    onAddressChange = () => {
        const place = this.autocomplete && this.autocomplete.getPlace();
        if (place) {
            const data = {
                address: place.formatted_address,
            };
            if (place.geometry) {
                const latLng = place.geometry.location.toJSON();
                data.lat = latLng.lat;
                data.lng = latLng.lng;
            }

            this.setState({ addressLoading: true });
            this.updateCommute(data)
                .then(({ geohash }) => {
                    this.setState(
                        {
                            geohash,
                            address: data.address,
                            addressLoading: false,
                        },
                        this.updateAnswer,
                    );
                })
                .catch(({ response }) => {
                    const state = {
                        addressLoading: false,
                        address: data.address,
                        geohash: response.status === 404 ? "ooa" : "",
                    };

                    this.setState(state, this.updateAnswer);
                });
        }
    };

    onAddressInputChange = () => {
        this.setState({ address: this.address.value }, this.updateAnswer);
    };

    onSelectChange = (event) => {
        const val = Number(event.target.value);
        this.setState(
            {
                selectValue: val || null,
            },
            this.updateAnswer,
        );
    };

    /**
     * Ah, addresses. If they don't click the Google result, we still wanna
     * calculate their geohash if we can, so we do that before they submit.
     */
    preSubmit = (answer) => {
        const { address } = this.state;

        if (!answer.response.geohash && address) {
            return this.updateCommute({ address })
                .then(({ geohash }) => ({
                    ...answer,
                    response: {
                        ...answer.response,
                        geohash,
                    },
                }))
                .catch(() => answer);
        }

        return new Promise((resolve) => {
            resolve(answer);
        });
    };

    updateCommute(data) {
        return post("/api/hire/v1/commute/", data);
    }

    updateAnswer() {
        const { address, geohash, onboarding } = this.state;

        const hasLocation = geohash || address;
        const canSubmit = !onboarding || hasLocation;
        const preSubmit = onboarding ? this.preSubmit : null;

        if (hasLocation) {
            saveCommuteData({ address, geohash });
        }

        this.props.handleAnswer({
            canSubmit,
            preSubmit,
            questionID: this.props.id,
            response: {
                commute_length: this.state.selectValue,
                geohash: this.state.geohash,
            },
        });
    }

    renderSelect() {
        const options = this.props.answer.map((a) => (
            <option key={a.id} value={a.id}>
                {a.value}
            </option>
        ));

        return (
            <div className="questions__pref-commute-length-select">
                <select onChange={this.onSelectChange}>{options}</select>
            </div>
        );
    }

    renderAddress() {
        const { address, addressLoading } = this.state;

        return (
            <div>
                <p className="questions__commute-from">from</p>
                <input
                    className="fs-hide"
                    type="text"
                    defaultValue={address}
                    disabled={addressLoading}
                    ref={(c) => (this.address = c)}
                    placeholder="Your address..."
                    onChange={this.onAddressInputChange}
                />
            </div>
        );
    }

    render() {
        return (
            <div>
                <label className="questions__title">{this.props.question}</label>
                {this.renderSelect()}
                {this.renderAddress()}
            </div>
        );
    }
}
